export var StoreLocatorEvents;
(function (StoreLocatorEvents) {
    StoreLocatorEvents["SearchClick"] = "store_locator_search";
})(StoreLocatorEvents || (StoreLocatorEvents = {}));
//# sourceMappingURL=useYandexMapsStoreLocator.types.js.map